import { useEffect } from 'react';
import { useCustomerChatbotContext } from '../use-customer-chatbot-context';

export const VISITED_PROPERTY_URLS_STORAGE_KEY = 'endion-visited-properties';

export function useSetVisitedPropertyUrlToSessionStorage() {
  const { customerChatbot, isLoading } = useCustomerChatbotContext();

  function matchUrl(url: string, patterns: string[]) {
    return patterns.some((pattern: string) => new RegExp(pattern).test(url));
  }

  useEffect(() => {
    const urlMatcher = customerChatbot?.urlMatcher;
    if (isLoading) return;
    if (!urlMatcher || urlMatcher.length === 0) return;

    const endionVisitedProperties = sessionStorage.getItem(VISITED_PROPERTY_URLS_STORAGE_KEY) || '[]';

    const visitedUrls = JSON.parse(endionVisitedProperties) as string[];
    const currentUrl = window.location.href;

    if (!visitedUrls.includes(currentUrl) && matchUrl(currentUrl, urlMatcher)) {
      visitedUrls.push(currentUrl);
      sessionStorage.setItem(VISITED_PROPERTY_URLS_STORAGE_KEY, JSON.stringify(visitedUrls));
    }

    const handlePopState = () => {
      const currentUrl = window.location.href;
      if (!visitedUrls.includes(currentUrl) && matchUrl(currentUrl, urlMatcher)) {
        visitedUrls.push(currentUrl);
        sessionStorage.setItem(VISITED_PROPERTY_URLS_STORAGE_KEY, JSON.stringify(visitedUrls));
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [customerChatbot, isLoading]);
}
